export const RUT_REGEX = /^\d{1,2}\.?\d{3}\.?\d{3}-?[\dkK]$/;

const clean = (value) => value.replace(/\./g, "").replace(/-/g, "");

const computeCheckDigit = (body) => {
    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
        sum += Number(body[i]) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const mod = 11 - (sum % 11);

    if (mod === 11) return "0";
    if (mod === 10) return "K";
    return String(mod);
};

export function isValidRutFormat(value) {
    return !!value && value.length <= 12 && RUT_REGEX.test(value);
}

export function isValidRutCheckDigit(value) {
    if (!isValidRutFormat(value)) return false;

    const clean1 = clean(value);
    const body = clean1.slice(0, -1);
    const dv = clean1.slice(-1).toUpperCase();

    return computeCheckDigit(body) === dv;
}

export function isValidRut(value) {
    return isValidRutFormat(value) && isValidRutCheckDigit(value);
}

export function normalizeRut(value) {
    const clean1 = clean(value);
    const body = clean1.slice(0, -1);
    const dv = clean1.slice(-1).toUpperCase();

    return `${body}-${dv}`;
}
